var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isOrdersModuleAvailable())?_c('div',{class:['tab-pane', _vm.currentTab === 'import-orders' ? 'active show' : '']},[(_vm.currentTab === 'import-orders')?_c('import-orders'):_vm._e()],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }